import { render } from "./regestration_page.vue?vue&type=template&id=66f0c82a&scoped=true"
import script from "./regestration_page.vue?vue&type=script&lang=js"
export * from "./regestration_page.vue?vue&type=script&lang=js"

import "./regestration_page.vue?vue&type=style&index=0&id=66f0c82a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f0c82a"]])

export default __exports__